import React, { useContext } from 'react';
import { Box, Chip, IconButton, Collapse, Badge, Typography } from '@mui/material';
import { FilterList } from '@mui/icons-material';
import { SearchContext } from '../contexts/SearchContext';

const ProductsTagFilters = ({ setTagFilter, tagFilter, tags, numProducts }) => {
  const { searchTags, fromSearch, setFromSearch } = React.useContext(SearchContext);
  const [showFilters, setShowFilters] = React.useState(false);

  React.useEffect(() => {
    if (searchTags.length > 0 && fromSearch) {
      setTagFilter(searchTags);
      setFromSearch(false);
    }
  }, [searchTags]);
  

  // Função para verificar se a tag está selecionada
  const isTagSelected = (tag) => tagFilter.some((selectedTag) => selectedTag.id === tag.id);

  // Função para alternar a tag no filtro
  const handleTagClick = (tag) => {
    if (isTagSelected(tag)) {
      // Remove a tag se já estiver selecionada
      setTagFilter(tagFilter.filter((selectedTag) => selectedTag.id !== tag.id));
    } else {
      // Adiciona a tag se não estiver selecionada
      setTagFilter([...tagFilter, tag]);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row' }}>
        <Typography onClick={() => setShowFilters(!showFilters)}>{numProducts} Itens
          <Badge badgeContent={tagFilter.length} color="primary">
            <IconButton>
              <FilterList/>
            </IconButton>
          </Badge>
        </Typography>
      </Box>
      <Collapse in={showFilters}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2, justifyContent: 'center' }}>
          {tags.sort((a, b) => a.name.localeCompare(b.name)).map((tag) => (
            <Chip
              key={tag.id}
              label={tag.name}
              variant={isTagSelected(tag) ? 'filled' : 'outlined'} // Muda o variant com base na seleção
              onClick={() => handleTagClick(tag)}
              sx={{
                // Opcional: adicionar estilos customizados para destacar a seleção
                ...(isTagSelected(tag) && {
                  // backgroundColor: '#f59723', // Cor de fundo quando selecionado
                  // color: 'white', // Cor do texto quando selecionado
                }),
              }}
            />
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default ProductsTagFilters;
